import { useLanguage } from '../../../../features/language/useLanguage';
import type { VoucherRow } from '../../../../services/subscriptionService';

const COLOR_MAP: Record<VoucherRow['status'], string> = {
  active: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  expired: 'bg-amber-50 text-amber-800 ring-amber-200',
  exhausted: 'bg-blue-50 text-blue-700 ring-blue-200',
  deleted: 'bg-gray-100 text-gray-500 ring-gray-200',
};

/** Colored pill rendering a voucher's lifecycle status. */
export function VoucherStatusBadge({ status }: { status: VoucherRow['status'] }) {
  const { t } = useLanguage();
  const labels: Record<VoucherRow['status'], string> = {
    active: t('subscription.voucher.status.active'),
    expired: t('subscription.voucher.status.expired'),
    exhausted: t('subscription.voucher.status.exhausted'),
    deleted: t('subscription.voucher.status.deleted'),
  };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium ring-1 ring-inset ${COLOR_MAP[status]}`}>
      {labels[status]}
    </span>
  );
}
